import { createAction } from '@reduxjs/toolkit';
import { LatLon } from './models';

export const addTemporaryLocationMarker = createAction(
  '[temporaryMarkers] Add temporary marker',
  (latlon: LatLon) => ({
    payload: latlon,
  }),
);

export const clearTemporaryLocationMarkers = createAction(
  '[temporaryMarkers] Clear all temporary markers',
);
